<template>
    <div class="base-spinner">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid"
            class="uil-ring-alt"
        >
            <rect x="0" y="0" width="100" height="100" fill="none" class="bk"></rect>
            <circle
                cx="50"
                cy="50"
                r="40"
                stroke="#e8e8e8"
                fill="none"
                :stroke-width="5"
                stroke-linecap="round"
            ></circle>
            <circle cx="50" cy="50" r="40" stroke="#97CE68" fill="none" :stroke-width="5" stroke-linecap="round">
                <animate
                    attributeName="stroke-dashoffset"
                    dur="1s"
                    repeatCount="indefinite"
                    from="0"
                    to="-502"
                ></animate>
                <animate
                    attributeName="stroke-dasharray"
                    dur="1.5s"
                    repeatCount="indefinite"
                    values="150.6 100.4;1 250;150.6 100.4"
                ></animate>
            </circle>
        </svg>
    </div>
</template>

<script>
    export default {}
</script>

<style lang="stylus" scoped></style>
